import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Box } from '@mui/material';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { IJobBoardSaveDTO, saveJobBoard } from 'wisestep-api';
import {
  ArrowButton,
  ControlledTextInput,
  WsButton,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';
import { object, string } from 'yup';

import { useSKUModalStore } from '../../../../components/skuModal/SKUModalStore';
import CareerBuilder from '../../../../images/jobBoardsIcons/CareerBuilder.png';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import {
  publishEmailValues,
  publishJobBoardValues,
} from '../../../jobs/publish/components/helper/jobBoardHelper';
import JobBoardSetting from '../../JobBoardSetting';
import { JobBoardDialogHeader } from '../freeJobBoardSetting/FreeJobBoardSetting';
import { addAccountFailed, addAccountSuccess } from '../helper/jobBoardSettingsHelper';

const validationSchema = object().shape({
  username: string().required('Username is required'),
  password: string()
    .min(4, 'Password must be at least 4 characters')
    .required('Password is required'),
});

const CareerBuilderNewAccount = () => {
  const navigate = useNavigate();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const jobBoardSave: IJobBoardSaveDTO = {
    jobBoard: publishJobBoardValues,
    email: publishEmailValues,
  };

  const setModal = useSKUModalStore((state) => state.setModal);

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const methods = useForm(formOptions);

  const { handleSubmit } = methods;

  const onFormSubmit = async (data: FieldValues) => {
    try {
      publishJobBoardValues.username = data.username;
      publishJobBoardValues.password = data.password;
      publishJobBoardValues.jobBoardName = 'CareerBuilder';
      jobBoardSave.jobBoard = publishJobBoardValues;
      await saveJobBoard(jobBoardSave);
      setNotification(addAccountSuccess());
      navigate('/job-boards/careerBuilder');
    } catch (error: any) {
      if (error.response.status == 402) {
        setModal({ object: error.response.data, type: 'count' });
      } else {
        setNotification(addAccountFailed());
      }
    }
  };

  return (
    <JobBoardSetting>
      <Box bgcolor="white">
        <JobBoardDialogHeader>
          <Grid item xs={12} container justifyContent="flex-start" columnGap={2}>
            <ArrowButton title="" onClick={() => navigate('/job-boards/careerBuilder')} />
            <img src={CareerBuilder} alt="CareerBuilder" height="35" />
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>
              Add new Career Builder account
            </WsTypography>
          </Grid>
        </JobBoardDialogHeader>
        <Grid container component="form">
          <Grid item xs={12} pl={4} pt={5}>
            <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
              Add account by configuring Career Builder account using RTP credentials.
            </WsTypography>
          </Grid>
          <FormProvider {...methods}>
            <Grid item xs={10} pt={4} pl={4}>
              <ControlledTextInput
                name="username"
                labelText="Username*"
                type="name"
                fullWidth
                id="outlined-basic"
                placeholder="Enter username"
                variant="outlined"
                required
                autoComplete="name"
              />
            </Grid>
            <Grid item xs={10} pt={4} pl={4}>
              <ControlledTextInput
                name="password"
                labelText="Password*"
                type="password"
                fullWidth
                id="outlined-basic"
                placeholder="Enter password"
                variant="outlined"
                required
                autoComplete="password"
              />
            </Grid>
          </FormProvider>
          <Grid item xs={12} p={4}>
            <WsButton
              variant="contained"
              size="large"
              type="submit"
              onClick={handleSubmit(onFormSubmit)}
            >
              Continue
            </WsButton>
          </Grid>
        </Grid>
      </Box>
    </JobBoardSetting>
  );
};

export default CareerBuilderNewAccount;
